module.exports = __webpack_public_path__ + "static/media/fox1_fox2-poster.26985f27.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/images/projects/fox1_fox2-poster.jpeg
// module id = 180
// module chunks = 0